// Generated by LiveScript 1.6.0
var ref$, map, keys, getKey, getParam, isDigit, replaceTrailingDigits, deepClone;
ref$ = require('./fn'), map = ref$.map, keys = ref$.keys;
getKey = function(prop, prefix){
  if (prefix === '') {
    return prop;
  } else {
    return prefix + "." + prop;
  }
};
getParam = function(el, attrName, isParametric){
  var val, idx;
  if (!isParametric) {
    return;
  }
  if (val = el.getAttribute(attrName)) {
    idx = val.indexOf(':');
    if (idx > -1) {
      return val.slice(idx + 1);
    }
  }
};
isDigit = function(it){
  return /^\d+$/.test(it);
};
replaceTrailingDigits = function(s, replacement){
  return s.replace(/\d+$/, replacement);
};
deepClone = function(obj){
  var result;
  switch (false) {
  case !(obj == null || typeof obj !== 'object'):
    return obj;
  case !Array.isArray(obj):
    return map(deepClone)(
    obj);
  default:
    result = Object.create(Object.getPrototypeOf(obj));
    map(function(k){
      return result[k] = deepClone(obj[k]);
    })(
    keys(obj));
    return result;
  }
};
module.exports = {
  getKey: getKey,
  getParam: getParam,
  isDigit: isDigit,
  replaceTrailingDigits: replaceTrailingDigits,
  deepClone: deepClone
};